var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, hasMany } from '@ember-data/model';
import { alias } from '@ember/object/computed';
import { fragment } from 'ember-data-model-fragments/attributes';
import CatalogObject, { CatalogObjectType } from '@square/dashboard-items-data/models/connect/catalog-object';
import { CatalogObjectType as CatalogObjectTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
import { isEmpty } from '@ember/utils';
let ModifierList = (_dec = attr('string', {
  protoEnum: CatalogObjectTypeProto,
  defaultValue: CatalogObjectType.MODIFIER_LIST
}), _dec2 = fragment('connect/modifier-list/data'), _dec3 = alias('modifierListData.name'), _dec4 = alias('modifierListData.internalName'), _dec5 = alias('modifierListData.ordinal'), _dec6 = alias('modifierListData.selectionType'), _dec7 = alias('modifierListData.modifierType'), _dec8 = alias('modifierListData.allowQuantities'), _dec9 = alias('modifierListData.maxQuantity'), _dec10 = alias('modifierListData.isConversational'), _dec11 = alias('modifierListData.maxLength'), _dec12 = alias('modifierListData.textRequired'), _dec13 = alias('modifierListData.channelIntegrations'), _dec14 = hasMany('connect/modifier', {
  async: false
}), _class = (_class2 = class ModifierList extends CatalogObject {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "type", _descriptor, this);
    _initializerDefineProperty(this, "modifierListData", _descriptor2, this);
    _initializerDefineProperty(this, "name", _descriptor3, this);
    _initializerDefineProperty(this, "internalName", _descriptor4, this);
    _initializerDefineProperty(this, "ordinal", _descriptor5, this);
    _initializerDefineProperty(this, "selectionType", _descriptor6, this);
    _initializerDefineProperty(this, "modifierType", _descriptor7, this);
    _initializerDefineProperty(this, "allowQuantities", _descriptor8, this);
    _initializerDefineProperty(this, "maxQuantity", _descriptor9, this);
    _initializerDefineProperty(this, "isConversational", _descriptor10, this);
    _initializerDefineProperty(this, "maxLength", _descriptor11, this);
    _initializerDefineProperty(this, "textRequired", _descriptor12, this);
    _initializerDefineProperty(this, "channelIntegrations", _descriptor13, this);
    _initializerDefineProperty(this, "modifiers", _descriptor14, this);
  }
  /**
   * The modifier name to use when displaying a modifier in Dashboard workflows
   * If the internal name exists, use that; otherwise, use the display name (aka name)
   */
  get modifierName() {
    return isEmpty(this.internalName) ? this.name : this.internalName;
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/modifier-list'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "modifierListData", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "internalName", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "ordinal", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "selectionType", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "modifierType", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "allowQuantities", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "maxQuantity", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "isConversational", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "maxLength", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "textRequired", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "channelIntegrations", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "modifiers", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ModifierList as default };